import React from 'react';
import './ShopPremiumItem.css';
import PageButton from '../../../elements/PageButton/PageButton';
import {getPremiumImagePath} from '../../../../utils/premium/getPremiumImagePath';
import {getFormattedPrice} from '../../../../utils/price/getFormattedPrice';
import {LoadedImage} from "../../../EmblaCarousel/FactionsCarousel";
import {MENU_SOUND_MANAGER} from "../../../../scenes/MenuSoundManager";
import {MINUS_SIGN, RUBLE_SIGN} from "../../../../constants/text";

const PAGE_ID = 'ShopPage';

function ShopPremiumItem({premium, onComingSoonClick}) {
  // Модалка с описанием премиума открывается кликом по всей плашке, не только
  // по кнопке «Скоро» (как у плашек сундуков). Кнопка гасит всплытие, чтобы
  // клик по ней не открывал модалку дважды; звук в обоих случаях — премиумный
  // (у кнопки стандартный звук PageButton отключен через noSound)
  const onCardClick = () => {
    MENU_SOUND_MANAGER.playPremium();
    onComingSoonClick?.();
  };

  const onButtonClick = (event) => {
    event.stopPropagation();
    MENU_SOUND_MANAGER.playPremium();
    onComingSoonClick?.();
  };

  return (
    <div
      className="shop-premium-item"
      onClick={onCardClick}
      style={{
        background: premium.backgroundColor,
      }}
    >
      <LoadedImage
        className="shop-premium-icon"
        src={getPremiumImagePath(premium.id)}
        alt={premium.name}
        placeholderSrc="/img/icons/premium.png"
      />
      <div className="shop-premium-name text-coins">{premium.name}</div>

      {premium.bonusCrystals > 0 && (
        <div className="shop-premium-bonus text-crystals">
          +{getFormattedPrice(premium.bonusCrystals)}
          <img className="shop-premium-bonus-icon" src="/img/icons/crystal.png" alt="Кристаллы"/>
        </div>
      )}

      <PageButton
        className="shop-premium-buy-button"
        onClick={onButtonClick}
        pageId={PAGE_ID}
        buttonId={`buy_premium_${premium.id}`}
        noSound={true}
        title={`Купить ${premium.name}`}
      >
        <span className="shop-premium-price">
          {getFormattedPrice(premium.priceRub)} {RUBLE_SIGN}
        </span>
        {premium.discountPercents > 0 && (
          <span className="shop-premium-discount-badge">
            {MINUS_SIGN}{premium.discountPercents}%
          </span>
        )}
      </PageButton>
    </div>
  );
}

export default ShopPremiumItem;
